<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de Imágenes de la Galería</h1>
    <div class="results" v-if="images">
      <div class="results__element" v-for="(image, index) in images" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="image.name"></h2>
          <p v-if="image.gallery_id" class="results__text" v-text="image.gallery_name"></p>
        </div>
        <div class="results__actions">
          <button @click.prevent="$parent.$emit('view', image.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Imagen</button>
          <button @click.prevent="$parent.$emit('edit', image.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Imagen</button>
          <button @click.prevent="deleteImage(image.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Imagen</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      imageId: null,
      images: null,
      confirm: false,
      galleryId: null
    }
  },
  created: function () {
    this.galleryId = this.$route.params.id
    this.getImages()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getImages()
    },
    '$store.state.elementChanged': function () {
      this.getImages()
    },
    '$route.path': function () {
      this.galleryId = this.$route.params.id
    }
  },
  methods: {
    getImages: function () {
      let httpRequest = {
        params: '?gallery_id=eq:' + this.galleryId + '&' + this.filters,
        module: 'gallery_images'
      }
      this.get(httpRequest)
        .then(
          images => {
            this.images = images.data
          }
        ).catch(
          () => {
            this.images = null
          }
        )
    },
    deleteImage: function (id) {
      this.confirm = true
      this.imageId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'gallery_images'
      }
      this.delete(this.imageId, httpRequest)
        .then(
          response => {
            this.getImages()
            this.$store.commit('notificate', {
              title: 'IMAGEN BORRADA',
              text: 'La imagen ha sido borrada correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'IMAGEN NO BORRADA',
              text: 'No se pudo borrar la imagen seleccionada, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery_images/list.vue